import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Appuntamento } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useAppuntamento, useDeleteAppuntamento, useUpdateAppuntamento } from '../../hooks/appuntamenti'
import AppuntamentoForm from '../../components/AppuntamentoForm'

export default function AppuntamentoEdit() {
  const { id } = useParams()
  const { data: appuntamento } = useAppuntamento(+id!)
  const deleteAppuntamento = useDeleteAppuntamento()
  const updateAppuntamento = useUpdateAppuntamento()
  const [modalRm, modalRmActions] = useModalTrigger<Appuntamento>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/appuntamenti">Appuntamenti</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {appuntamento?.titolo}
            </li>
          </ol>
        </nav>
        <div className="d-flex align-items-center">
          <button
            className="btn btn-danger"
            onClick={() => modalRmActions.open(appuntamento)}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </div>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <AppuntamentoForm
          appuntamento={appuntamento}
          save={(appuntamento) =>
            updateAppuntamento.mutateAsync(appuntamento).then(() =>
              toast.success('Appuntamento  salvato con successo', {
                position: toast.POSITION.TOP_RIGHT,
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare l' appuntamento {modalRm.value.titolo} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deleteAppuntamento.isLoading}
            onClick={async () => {
              await deleteAppuntamento.mutateAsync(modalRm.value!.id)
              navigate('/appuntamenti')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
